wbApp.factory('formSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {
        var Form = $resource('/restapi/forms-definitions/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/forms-definitions/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/forms-definitions' },
            'getAllActive': { method: 'GET', isArray: true, url: '/restapi/forms-definitions/find-by-active' },
            'getByIdAndRevision': { method: 'GET', url: '/restapi/forms-definitions/:id/audit/:revision' },
            'insert': { method: 'POST', url: '/restapi/forms-definitions' },
            'update': { method: 'PUT', url: '/restapi/forms-definitions/:id' },
            'delete': { method: 'DELETE', url: '/restapi/forms-definitions/:id' },

        });

        function createNew()
        {
            var form = {                
                name: '',
                primaryQuestionIndex: 0,
                primaryQuestionIndexPlusOne: 1,
                accessPermissions: 0,
                isActive: true,
                questions: [],
                isNew: true,
                formType: 0
            };

            addNewQuestion(form);

            return form;
        }

        function addNewQuestion(form)
        {
            if (!form.questions) {
                form.questions = [];
            }

            var maxId = 1;
            var max = _.maxBy(form.questions, 'id');
            if (!!max) {
                maxId = max.id + 1;
            }

            var newQuestion = {
                id: maxId + 1,
                name: "",
                descriptionHtml: "",
                questionType: 0,
                options: []
            };

            addNewOption(newQuestion);

            form.questions.push(newQuestion);
        }

        function addNewOption(question)
        {
            if (!question.options) {
                question.options = [];
            }

            var maxId = 1;
            var max = _.maxBy(question.options, 'id');
            if (!!max) {
                maxId = max.id + 1;
            }

            var newOption = {
                id: maxId + 1,
                name: ""
            };

            question.options.push(newOption);
        }

        function isFormValid(form)
        {
            if (form.questions == null || form.questions.length == 0)
            {
                return false;
            }

            if (form.primaryQuestionIndex > (form.questions.length - 1) ||
                form.primaryQuestionIndex < 0)
            {
                return false;
            }

            return _.reduce(form.questions, function (result, q) {
                var questionIsValid = true;
                if (q.questionType != 4)
                {
                    questionIsValid = q.options != null && q.options.length > 0;
                }
                else
                {
                    questionIsValid = q.options == null;
                }
                return result && questionIsValid;
            }, true);
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                Form,
                model);
        }

        function remove(formId) {
            return repositorySvc.customDelete(
                'delete',
                Form,
                { id: formId });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                Form,
                { id: model.id },
                model);
        }

        function getById(formId) {
            return repositorySvc.customGet('getById', Form, { id: formId });
        }

        function getByIdAndRevision(formId, revision) {
            return repositorySvc.customGet('getByIdAndRevision', Form, { id: formId, revision: revision });
        }

        function getAll() {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getAll',
                    Form,
                    {
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }

        function getAllActive() {
            return $q(function (resolve, reject) {
                var getResult = repositorySvc.customGet(
                    'getAllActive',
                    Form,
                    {
                    });

                getResult.$promise.then(
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(error);
                    });
            });
        }
        
        function getAllForLookup(formIdToInclude, filterForKindergarten)
        {
            let allForms = getAll();
            var filteredForms = [];

            var deferred = $q.defer();
            filteredForms.$promise = deferred.promise;

            allForms.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (value.isActive || value.id === formIdToInclude) {
                        if (!!filterForKindergarten) {
                            if (value.formType === 1 /* KindergartenEnrollment */ || value.id === formIdToInclude) {
                                filteredForms.push(value);    
                            }
                        } else {
                            filteredForms.push(value);
                        }
                    }
                });
                deferred.resolve(filteredForms);
            }, function (reason) {
                deferred.reject(reason);
            });

            return filteredForms;
        }

        function updateFilledFormByFormResponse(form, formResponse) {

            form.notRegisteredUserInfo = formResponse.notRegisteredUserInfo;
            form.isNotRegisteredUser = !!form.notRegisteredUserInfo;

            var student = _.find(form.students, function (s) { return s.id == formResponse.studentId; });
            if (!!student) {
                student.checked = true;
            }

            _.forEach(formResponse.answers, function (a) {
                var q = _.find(form.questions, { id: a.id });
                if (!!q) {
                    q.textAnswer = a.textAnswer;
                    if (!!a.optionsSelection && a.optionsSelection.length > 0) {
                        _.forEach(a.optionsSelection, function (os) {
                            var o = _.find(q.options, { id: os });
                            if (!!o) {
                                o.checked = true;
                            }
                        });
                    }
                }
            });

        }

        function generateFormResponseFromFilledForm(form)
        {
            return {
                id: null,
                formDefinitionId: form.id,
                formDefinitionRevision: form.auditEvent != null ? form.auditEvent.revision : 0,
                userId: !form.notRegisteredUserInfo ? form.userId + '' : null,
                studentId: !form.notRegisteredUserInfo 
                    ? _.head(_.map(_.filter(form.students, { 'checked': true }), function (s) {
                        return s.id + '';
                        }))
                    : null,
                answers: _.map(form.questions, function (q) {
                    return {
                        id: q.id,
                        textAnswer: q.textAnswer,
                        optionsSelection: (q.questionType == 4)  
                            ? undefined
                            : _.map(_.filter(q.options, { 'checked': true }), 'id')
                    }
                }),
                isNotRegisteredUser: !!form.notRegisteredUserInfo,
                notRegisteredUserInfo: form.notRegisteredUserInfo
            };
        }

        return {
            createNew: createNew,
            getById: getById,
            getByIdAndRevision: getByIdAndRevision,
            getAll: getAll,
            getAllActive: getAllActive,
            insert: insert,
            remove: remove,
            update: update,
            addNewQuestion: addNewQuestion,
            addNewOption: addNewOption,
            isFormValid: isFormValid,
            generateFormResponseFromFilledForm: generateFormResponseFromFilledForm,
            updateFilledFormByFormResponse: updateFilledFormByFormResponse,
            getAllForLookup: getAllForLookup
        }
    }
]);